import axiosMain from "@/axios/index";

let _local_id_index = 1;
export function getLocalId(){
  let i = _local_id_index++;
  return `${i}_${Date.now()}_${Math.round(Math.random() * 100)}`;
}

/**
 * 从多级列表数组中查找[id,id,id,....]匹配的数据项并返回
 * @param list        {array}   多级列表数据
 * @param valueArray  {array}   多级列表对应匹配值
 * @param index       {number}  匹配层级,从0开始自增
 * @param prop        {object}  其他可配置化参数
 * @returns {*}
 */
export function findChildrenItem(list = [],valueArray = [],index = 0,prop={}){
  prop = Object.assign({value:'value',children:'children',resultType:''},prop);
  let results = [list.find(item => item[prop.value] === valueArray[index])];
  if(results[0] && (valueArray.length > ++index)) results.push(...findChildrenItem(results[0][prop.children],valueArray,index,prop));
  if(prop.resultType.toLowerCase() === 'array' || index !==1 ) return results;
  else return results[results.length - 1];
}

/**
 * 将多级列表数组从截取对应层级的新数组
 * @param list
 * @param prop
 * @param level
 */
export function setArrayChildrenLevel(list = [],prop = {},level = 0){
  prop = Object.assign({children:'children',level:3},prop);
  if(level === 0) try {
    list = JSON.parse(JSON.stringify(list));
  }catch (e) {
    list = []
  }
  list.forEach(item=>{
    let children = item[prop.children];
    if(level + 1 >= prop.level){
      delete item[prop.children];
    }else if(children instanceof Array){
      setArrayChildrenLevel(children,prop,level + 1);
    }
  });
  return list
}

/**
 * 处理搜索数据
 * @param data
 */
export function disposeSearchData(data){
  if(data.searchType && data.searchValue){
    data[data.searchType] = data.searchValue
  }
  if(data.searchType) delete data.searchType;
  if(data.searchValue) delete data.searchValue;
  objectRemoveEmpty(data);
  return data
}

/**
 * 清空对象中值为空的key
 * @param data
 * @returns {*}
 */
export function objectRemoveEmpty (data) {
  let keys = Object.keys(data).filter(res=>empty(data[res]));
  keys.forEach(key=>{
    delete data[key]
  });
  function empty(res){
    if(res === 0) return false;
    return isEmpty(res)
  }
  return data
}

/**
 * 判断为空
 * @param val
 * @returns {boolean}
 */
export const isEmpty = function(val) {
  // null or undefined
  if (val === null) return true;

  if (typeof val === 'boolean') return false;

  if (typeof val === 'number') return !val;

  if (val instanceof Error) return val.message === '';

  switch (Object.prototype.toString.call(val)) {
    // String or Array
    case '[object String]':
    case '[object Array]':
      return !val.length;

    // Map or Set or File
    case '[object File]':
    case '[object Map]':
    case '[object Set]': {
      return !val.size;
    }
    // Plain Object
    case '[object Object]': {
      return !Object.keys(val).length;
    }
  }

  return false;
};

/**
 * 下载Excel
 * @param url
 */
export function downloadExcel(url = ''){
  if(!url) return false;
  try {
    window.location.href = url;
  }catch (e) {
    window.location = url;
  }
}

/**
 * 获取element组件form表单的验证结果
 * @param form
 * @param filter // 是否只返回error信息
 * @returns {{validateMessage: *, label: *, validateState: *}[]}
 */
export function getElFormValidateValue(form,filter=true){
  // form = this.$refs[formName];
  let fields = form.fields;
  let list = fields.map(item=>{
    return {
      label:item.$props.label,
      state:item.$data.validateState,
      message:item.$data.validateMessage,
    };
  });
  if(filter) return list.filter(res=> res.state === 'error');
  return list;
}

/**
 * 打印表单验证错误结果
 * @param res
 */
export function notifyFormValidateErrorInfo(res) {
  this.$notify({
    title: '表单校验不通过',
    dangerouslyUseHTMLString: true,
    message: res.map(res=>`<p><span class="color-danger">${res.label}：</span>${res.message}</p>`).join(''),
    type: 'warning'
  });
}


/**
 * 将字符串截取逗号','转为数组
 * @param str
 * @param s
 * @returns {*}
 */
export function stringToArray(str='',s=',') {
  if(!str) return [];
  let reg = new RegExp(s,'ig');
  if(!reg.test(str)) return [str];
  return str.split(s);
}

/**
 * 将 数组中有值的label、value 隐射为对应{value:label}
 * @param keyName
 * @param arr
 * @param prop
 * @returns {{}}
 */
export function mapFromArrayToObject(arr = [], prop = {}) {
  if (!Array.isArray(arr)) return {};
  if (arr.length <= 0) return {};
  prop = Object.assign({label: 'label', value: 'value'}, prop);
  let obj = {};
  arr.forEach(res => {
    if (res[prop.label] !== '全部' && res[prop.label] !== undefined && res[prop.value] !== undefined) {
      obj[res[prop.label]] = res[prop.value];
      obj[res[prop.value]] = res[prop.label];
    }
  });
  return obj;
}

/**
 * 将数组对象中 对应的key转换为label,value
 * @param list
 * @param prop
 * @returns {*}
 */
export function mapArrayObjectKeyName(list = '', prop = {}) {
  if (!Array.isArray(list)) return [];
  if (list.length <= 0) return [];
  prop = Object.assign({label: 'label', value: 'value'}, prop);
  list.forEach(res => {
    if (typeof res.label === "undefined" && res[prop.label]) {
      res.label = res[prop.label];
    }
    if (typeof res.value === "undefined" && res[prop.value]) {
      res.value = res[prop.value];
    }
  });
  return list;
}

/**
 * 下载文件(装箱单)模板
 * @param url
 * @param fileName
 * @param fileType
 * @param data
 * @param method
 * @returns {Promise<never>|Promise<AxiosResponse<any>>}
 */
export function downFileTemplate(url="",fileName="装箱单模板",fileType="xls",data,method="get") {
  if(!url) return Promise.reject(Error(`params "url" not is undefined`));
  let fun;
  if(!method) method = "get";
  if(method.toLowerCase() === "post"){
    fun = axiosMain.post(url,data,{
      responseType: "arraybuffer",
    });
  }else{
    fun = axiosMain.get(url, {
      params:data,
      responseType: "arraybuffer",
    })
  }
  return fun
    .then(res => {
      let a = document.createElement("a");
      let blob = new Blob([res.data]);
      let objectUrl = URL.createObjectURL(blob);
      a.setAttribute("href", objectUrl);
      a.setAttribute("download", `${fileName}.${fileType}`);
      a.click();
      URL.revokeObjectURL(objectUrl); // 释放URL 对象
    })
    // .catch(e => {
    //   this.$message.error(`下载文件：` + (e.message||"失败"));
    //   return Promise.reject(Error(`下载文件：${e.message||"失败"}`));
    // });
}
import {isProduction} from '../../../devParams'
/**
 * 获取微信扫码跳转origin
 * @returns {string|string}
 */
export function getWebLocationOrigin(){
  return isProduction ? location.origin : "https://qa2.huodaipin.com.cn" ;
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js